<template>
	<div class="head-CreateUser" :style="{backgroundColor: headerColor}">
      <div class="sidebar-action sidebar-action--hidden" :class="{'sidebar-action--showIt': showSidebar}" @click="eventShowIt()" v-if="!$route.meta.hideSidebar">
        <i class="material-icons">menu</i>
      </div>
      <slot></slot>
			<div class="wrap-info">
        <template v-if="subtitleOpt">
          <h4><span class="content-title">{{option.headText}}</span><span class="content-separator"><i class="item_icon material-icons separator">chevron_right</i></span><span>{{option.subtitle}}</span></h4>   
        </template>
        <template v-else>
          <h4><span>{{option.headText}}</span></h4>
        </template>
				
			</div>
		</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "headView",
  props: {
    option: {
      type: Object,
      default() {
        return {
          subtitle: String,
          headText: String
        };
      }
    },
    subtitleOpt: Boolean
  },
  computed:{
    ...mapGetters(['company','headerColor','showSidebar', "role"])
  },
  data() {
    return {
      valueBtn: "usuario nuevo",
      items: [
        {
          title: this.option.headText,
          active: false
        },
        {
          title: this.option.subtitle,
          active: true
        }
      ],
      showIt: false
    };
  },
  methods: {
    actionToLink: function() {
      this.$router.push("/newuser");
    },
    eventShowIt(){
      this.$store.commit("viewSidebar");
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/styles/2.tools/mixins/_mediaquerys.scss";
.head-CreateUser {
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
  text-align: left;
  font-size: 18px;
  padding: 20px 0;
  padding-left: 35px;
  @include media-xl{
    padding-left: 30px;
  }
  background-color: #384a5d;
  color: white;
  z-index: 101;
  // .btn-render-plus {
  //   height: 60px;
  //   padding: 0 15px;
  //   position: absolute;
  //   top: 0;
  //   right: 0;
  //   border-left: 1px solid white;
  //   font-size: 18px;
  //   line-height: 19px;
  //   // display: none;
  //   display: flex;
  //   align-items: center;
  //   .space-text {
  //     padding-right: 6px;
  //     padding-left: 10px;
  //   }
  //   .space-icon{
  //     max-width: 50px;
  //     padding-right: 10px;
  //     padding-left: 10px;
  //   }
  //   cursor: pointer;
  // }
  .wrap-info {
    h4 {
      font-weight: normal;
      min-width: 500px;
      text-overflow: ellipsis;
      line-height: 18px;
      // margin-left: 20px;
    }
    // &--main {
    //   margin-right: 4px;
    // }
    .content-title {
      margin-right: 18px;
    }
    .content-separator {
      position: relative;
      .separator {
        position: absolute;
        top: -1px;
        left: -18px;
        font-size: 18px;
      }
    }
  }
  /*----------------*/
  .breadcrumd-head {
    ol {
      padding: 0;
      .disabled-link {
        a {
          color: white !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Componentes/headView.vue